import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Switch from '@mui/material/Switch';
import styled from 'styled-components';
import Container, { Modal, Buttons, Cancel, Validate } from './styles';
import Availability from '../AnnounceModal/Availability';
import Header from './Header';
import Notice from './Notice';

const AvailabilityModal = ({ className, isModalOpen, availabilityToggle }) => {
  const [state, setState] = useState({
    checkedA: true,
    checkedB: true,
  });

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isModalOpen]);

  const handleChange = ({ target }) => {
    const { name, checked } = target;
    setState({ ...state, [name]: checked });
  };

  return (
    <Container className={className} isModalOpen={isModalOpen}>
      <Modal>
        <Header availabilityToggle={availabilityToggle} />
        <Notice />
        <div className="container">
          <div className="switch">
            <span>J&apos;ai une parcelle de libre aujourd&apos;hui !</span>
            <Switch
              checked={state.checkedB}
              onChange={handleChange}
              color="primary"
              name="checkedB"
            />
          </div>
          <Availability />
        </div>
        <Buttons>
          <Cancel type="button" onClick={availabilityToggle}>
            Annuler
          </Cancel>
          <Validate type="button" onClick={availabilityToggle}>
            Valider
          </Validate>
        </Buttons>
      </Modal>
    </Container>
  );
};

AvailabilityModal.propTypes = {
  className: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  availabilityToggle: PropTypes.func.isRequired,
};

export default styled(AvailabilityModal)`
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    .switch {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
  }
`;
